import React, { Component } from "react";
import { connect } from "react-redux";

import awbRemote from "../../../api/awbRemote";
import pickupOrderRemote from '../../../api/pickupOrderRemote';

import ApiResponse from "../../../models/ApiResponse";
import ResponseError from "../../../models/ResponseError";
import Awb from "../../../models/Awb";
import PickupOrderGha from '../../../models/PickupOrderGha';

import ManageUnrecognizedDocComponent from "./ManageUnrecognizedDoc";
import unrecognizedDocsStyles from "./ManageUnrecognizedDoc.module.css";
import commonStyles from '../../common/common.module.css';
import ViewDocuments from './ViewDocuments';

import UnrecognizedDocsListComponent from "./UnrecognizedDocsListComponent";
import { receiveError } from "../../../store/actions/notificationAction";

import attachmentsRequestHandler from '../../../api/attachmentsRemote';
import ConfirmationDialog from '../../confirmation/ConfirmationDialog';
import AwbDetails from "../../../models/AwbDetails";
import UnrecognizedDocs from "../../../models/AutoDocRecognitionResponse";
import moment, { Moment } from 'moment';

import { Grid } from "@material-ui/core";

interface ManageUnrecognizedDocContainerProps {
  receiveError: (error: ResponseError) => void;
  displayUnrecognizedDocs: boolean;
};

const UNRECOGNIZED_DOCS_INITIALS: UnrecognizedDocs = {
  id: -1,
  source_email: '',
  scanner_from_email: '',
  id_message: '',
  message_details: [],
  attachment_key: '',
  doc_scan_sent_response: null,
  doc_scan_received_response: null,
  status: '',
  created_dt: '',
  updated_dt: '',
  deleted: false,
  received_date: null
};

interface ManageUnrecognizedDocContainerState {
  awb: Array<Awb>;
  isAttachmentsDialogOpen: boolean;
  unrecognizedDocsListNw: Array<UnrecognizedDocs>;
  displayUnrecognizedDocs: boolean;
  selUnrecognizedDoc: string;
  isAttachmentDeleteConfirmationOpen: boolean;
  unrecognizedDocData: any; //UnrecognizedDocs;
  key: string;
  awb_num: string;
  awbNumError: string;
  attachmentType: string;
  DocData: Array<UnrecognizedDocs>;
  attachToType: string;
  attachToTypeError: string;
  order_num: string;
  orderNumError: string;
  rfs_no: string;
  rfsNoError: string;
  rfsDate: Moment;
  rfs_date: string;
  attachmentOtherName: string;
  progress: boolean; 
};

class ManageUnrecognizedDocContainer extends Component<ManageUnrecognizedDocContainerProps, ManageUnrecognizedDocContainerState> {

  state: ManageUnrecognizedDocContainerState = {
    awb: [],
    isAttachmentsDialogOpen: false,
    unrecognizedDocsListNw: [],
    displayUnrecognizedDocs: this.props.displayUnrecognizedDocs,
    selUnrecognizedDoc: '',
    isAttachmentDeleteConfirmationOpen: false,
    unrecognizedDocData: [], //UNRECOGNIZED_DOCS_INITIALS,
    progress: false,
    key: '',
    attachmentOtherName: '',
    awb_num: '',
    awbNumError: '',
    DocData: [],
    attachToType: '',
    attachToTypeError: '',
    order_num: '',
    orderNumError: '',
    rfs_no: '',
    rfsNoError: '',
    rfsDate: moment(),
    attachmentType: 'awb_airwaybill',
    rfs_date: moment().format('YYYYMMDD')
  };

  componentDidMount() {
    this.loadUnrecognizedDocs();
  }

  handleOpenModal = (): void => {
    this.setState({ isAttachmentsDialogOpen: true });
  };

  handleCloseModal = (): void => {
    this.setState({ isAttachmentsDialogOpen: false });
  };

  handleChangeUnrecognizedDoc = (event: any, type: string): void => {

    let selVal: string = type == 'manual' ? event.target.value : event.toString();
    this.setState({ selUnrecognizedDoc: selVal, isAttachmentsDialogOpen: true });
    attachmentsRequestHandler.getUnrecognizedAttachementById(selVal).then((resp: ApiResponse<UnrecognizedDocs>) => {
      const result: UnrecognizedDocs | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;
      const docDataArr = [];

      if (result) {
        docDataArr.push(result);
        this.setState({ unrecognizedDocData: result, DocData: docDataArr, attachToType: 'awb_no' });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });

  }

  loadUnrecognizedDocs = (): void => {
    attachmentsRequestHandler.loadUnrecognizedAttachments().then((resp: ApiResponse<Array<UnrecognizedDocs>>) => {
      const result: Array<UnrecognizedDocs> | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (result) {
        this.setState({ unrecognizedDocsListNw: result });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  }

  handleDelete = (key: string): void => {
    this.setState({ isAttachmentDeleteConfirmationOpen: true, key });
  };

  deleteUnrecognizedDoc = (): void => {
    attachmentsRequestHandler.deleteUnrecognizedAttachment(this.state.key).then((resp: ApiResponse<boolean>) => {
      const result: boolean | undefined = resp.success;
      const error: ResponseError | undefined = resp.error;

      if (result) {
        this.loadUnrecognizedDocs();
        this.setState({ isAttachmentDeleteConfirmationOpen: false });
        this.setState({ selUnrecognizedDoc: '', isAttachmentsDialogOpen: false });
      }

      if (error) {
        this.props.receiveError(error);
      };
    });
  };

  changeAttachmentType = (event:any):void => {
    this.setState({attachmentType: event.target.value});
  }

  handleChange = (attachTo: string, event: any): void => {
    if (attachTo == 'awb_no') {
      let value: string = event.target.value.toString();
      if (value.length === 3 && this.state.awb_num.length === 2) {
        value = value + '-';
      }
      if (value.length === 11) {
        if (value.indexOf('-') < 0) {
          value = value.slice(0, 3) + '-' + value.slice(3);
        }
      }
      if (value.split('-').length > 2) {
        return;
      }
      this.setState({ awb_num: value });
    }
    if (attachTo == 'order_no') {
      this.setState({ order_num: event.target.value.toString() });
    }
    if (attachTo == 'rfs_no') {
      this.setState({ rfs_no: event.target.value.toString() });
    }
    if (attachTo == 'attachment_other') {
      this.setState({ attachmentOtherName: event.target.value.toString() });
    }
    if (attachTo == 'rfs_date') {
      this.setState({ rfs_date: event.format('YYYYMMDD'), rfsDate: event });
    }
  };

  handleClick = (): void => {
    this.setState({ awbNumError: '', attachToTypeError: '', orderNumError: '', rfsNoError: '' })
  };

  handleNextUnrecognizedDoc = () => {
    const docList = [...this.state.unrecognizedDocsListNw];
    const currentIndex = docList.findIndex(d => d.id === Number(this.state.selUnrecognizedDoc));
    let nextIndex = currentIndex + 1;
    if (nextIndex >= docList.length) {
      nextIndex = 0;
      if (nextIndex === currentIndex) {
        nextIndex = -1;
      }
    }
  
    if (docList.length > 0 && nextIndex !== -1) {
      this.handleChangeUnrecognizedDoc(docList[nextIndex].id, 'auto');
    }
    docList.splice(currentIndex, 1);
    this.setState({ unrecognizedDocsListNw: docList });
  }

  handleLinkDocToAwb = (): void => {
    if (this.state.attachToType != '' && (this.state.attachmentType || (this.state.attachmentType === 'awb_other' && this.state.attachmentOtherName))) {
      switch (this.state.attachToType) {
        
        case 'order_no':
          if (this.state.order_num != '') {
            let order_num = this.state.order_num;
            this.setState({ progress: true }, () => {
              
              pickupOrderRemote.getGhaPickupOrderList(order_num).then((resp: ApiResponse<PickupOrderGha>) => {

                const po: PickupOrderGha | undefined = resp.result;
                const error: ResponseError | undefined = resp.error;

                if (po) {
                  let mail_received_dt = null;
                  if (this.state.unrecognizedDocData) {
                    let mail_dt = this.state.unrecognizedDocData.message_details.payload.headers.find((msg: any) => msg.name === 'Date');
                    mail_received_dt = mail_dt.value;
                  }
                  const attachmentType = this.state.attachmentType === 'awb_other' ? this.state.attachmentOtherName : this.state.attachmentType;
                  attachmentsRequestHandler.addAttachmentForAwbOrOrder(null, po.id, this.state.unrecognizedDocData.attachment_key, this.state.unrecognizedDocData.scanner_from_email, mail_received_dt, this.state.unrecognizedDocData.id_message, this.state.unrecognizedDocData.source_email, attachmentType).then((resp: ApiResponse<any>) => {
                    const result: boolean | undefined = resp.success;
                    const error: ResponseError | undefined = resp.error;

                    if (result) {
                      
                      this.handleNextUnrecognizedDoc();
                      this.setState({ attachToType: '', awb_num: '',order_num: '', attachmentOtherName: '', progress: false });

                    }
                  });
                }
                if (error) {
                  this.props.receiveError(error);
                  this.setState({ awb_num: '', order_num: '', progress: false });
                }
              });
            });
          }
          else {
            this.setState({ orderNumError: 'Add Order Number', progress: false });
          }
        break;

        case 'rfs_no':
          if (this.state.rfs_no != '') {
            let airlineCode: string = this.state.rfs_no.replace(/[^A-Za-z]/g, '');
            let rfsNumber: string = this.state.rfs_no.replace(/[A-Za-z]/g, '');
            this.setState({ progress: true }, () => {

              attachmentsRequestHandler.checkOfflineRfsOrderExists(airlineCode, rfsNumber, this.state.rfs_date).then((resp: ApiResponse<any>) => {

                const rfsResult: any | undefined = resp.result;
                const error: ResponseError | undefined = resp.error;

                if (rfsResult) {
                  let mail_received_dt = null;
                  if (this.state.unrecognizedDocData) {
                    let mail_dt = this.state.unrecognizedDocData.message_details.payload.headers.find((msg: any) => msg.name === 'Date');
                    mail_received_dt = mail_dt.value;
                  }
                  const attachmentType = this.state.attachmentType === 'awb_other' ? this.state.attachmentOtherName : this.state.attachmentType;
                  attachmentsRequestHandler.addUnrecognizedAttachmentForOfflineRfs(rfsResult.id, this.state.unrecognizedDocData.attachment_key, this.state.unrecognizedDocData.scanner_from_email, mail_received_dt, this.state.unrecognizedDocData.id_message, this.state.unrecognizedDocData.source_email, attachmentType).then((resp: ApiResponse<any>) => {
                    const result: boolean | undefined = resp.success;
                    const error: ResponseError | undefined = resp.error;

                    if (result) {
                      
                      this.handleNextUnrecognizedDoc();
                      this.setState({ attachToType: '', awb_num: '',order_num: '',rfs_no: '',rfsDate: moment(),rfs_date: moment().format('YYYYMMDD'), attachmentOtherName: '', progress: false });

                    }
                  });
                }
                if (error) {
                  error.longDescription = "Cannot find that RFS";
                  this.props.receiveError(error);
                  this.setState({ awb_num: '', order_num: '', rfs_no: '', rfsDate: moment(), rfs_date: moment().format('YYYYMMDD'), progress: false });
                }
              });
            });
          }
          else {
            this.setState({ rfsNoError: 'Add RFS #', progress: false });
          }
        break;
        
        case 'awb_no':
          if (this.state.awb_num != '') {
            const awb_arr = this.state.awb_num.split('-');
            let code = awb_arr[0];
            let number = awb_arr[1];
            this.setState({ progress: true }, () => {

              awbRemote.getAwbInfo(code, number, 0).then((res: ApiResponse<AwbDetails>) => {

                const result: AwbDetails | undefined = res.result;
                const error: ResponseError | undefined = res.error;

                if (result) {
                  this.setState({
                    awb: [result.awb]
                  });
                  let mail_received_dt = null;
                  if (this.state.unrecognizedDocData) {
                    let mail_dt = this.state.unrecognizedDocData.message_details.payload.headers.find((msg: any) => msg.name === 'Date');
                    mail_received_dt = mail_dt.value;
                  }
                  const attachmentType = this.state.attachmentType === 'awb_other' ? this.state.attachmentOtherName : this.state.attachmentType;
                  attachmentsRequestHandler.addAttachmentForAwbOrOrder(this.state.awb[0].id, null, this.state.unrecognizedDocData.attachment_key, this.state.unrecognizedDocData.scanner_from_email, mail_received_dt, this.state.unrecognizedDocData.id_message, this.state.unrecognizedDocData.source_email, attachmentType).then((resp: ApiResponse<any>) => {
                    const result: boolean | undefined = resp.success;
                    const error: ResponseError | undefined = resp.error;

                    if (result) {

                      this.handleNextUnrecognizedDoc();
                      this.setState({ attachToType: '', awb_num: '', attachmentOtherName: '', progress: false }); 

                    }
                  });
                }
                if (error) {
                  this.props.receiveError(error);
                  this.setState({ awb_num: '', progress: false });
                }
              });

            });
          }
          else {
            this.setState({ awbNumError: 'Add AirwayBill Number', progress: false });
          }
        break;
        default: break;
      }
    }
    else {
      this.setState({ attachToTypeError: 'Select Attach Document To' });
    }
  };

  onChange = (event: any): void => {
    let value: string = event.target.value.toString();
    if (value) {
      if (value != '-1') {
        switch (value) {
          case 'order_no':
            this.setState({ attachToType: 'order_no' });
          break;
          case 'rfs_no':
            this.setState({ attachToType: 'rfs_no' });
          break;
          case 'awb_no':
            this.setState({ attachToType: 'awb_no' });
          break;
          default: break;
        }
      }
      else {
        this.setState({ attachToType: '', awb_num: '', order_num: '', rfs_no: '', attachToTypeError: '' });
      }
    }
  };

  render() {

    return (
      <div>
        <div className={ commonStyles.headerDummyDiv }></div>
        <div className= {`${ unrecognizedDocsStyles.mainContainer } ${ commonStyles.wrapper }`}>
          <div className={ unrecognizedDocsStyles.inspectionHeader }>
            <div className={ `${ commonStyles.header } ${ unrecognizedDocsStyles.inspectionHeaderText }` }>Un-Recognized Documents</div>
            <div className={ unrecognizedDocsStyles.inspectionHeaderButton }>
            </div>
          </div>
          <div
            className={ [unrecognizedDocsStyles.alignTop, unrecognizedDocsStyles.unrecognizedOuterWrapper].join(" ") }
          >
            <Grid container direction="row" className={ unrecognizedDocsStyles.unrecognizedDocgridContainer }>
              <Grid item xs="auto" className={ unrecognizedDocsStyles.unrecognizedDocgrid }>
                <UnrecognizedDocsListComponent
                  unrecognizedDocsList={ this.state.unrecognizedDocsListNw }
                  handleChangeUnrecognizedDoc={ this.handleChangeUnrecognizedDoc }
                  selUnrecognizedDoc={ this.state.selUnrecognizedDoc }
                />
              </Grid>
              <Grid item xs="auto" className={ [unrecognizedDocsStyles.unrecognizedDocgrid, unrecognizedDocsStyles.unrecognizedDocPreview, unrecognizedDocsStyles.unrecognizedDocPreviewDoc].join(" ") } >
                <p className={ unrecognizedDocsStyles.unrecognizedDocTitle }>Documents Preview</p>
                <div>
                  { this.state.isAttachmentsDialogOpen && (
                    <ViewDocuments
                      docData={ this.state.DocData }
                    />
                  ) }
                </div>

              </Grid>
              <Grid item xs="auto" className={ [unrecognizedDocsStyles.unrecognizedDocgrid, unrecognizedDocsStyles.manageunrecognizedDoc].join(" ") }>
                <ManageUnrecognizedDocComponent
                  unrecognizedDocData={ this.state.unrecognizedDocData }
                  handleDelete={ this.handleDelete }
                  selUnrecognizedDoc={ this.state.selUnrecognizedDoc }
                  awb_num={ this.state.awb_num }
                  awb_numError={ this.state.awbNumError }
                  handleChange={ this.handleChange }
                  handleLinkDocToAwb={ this.handleLinkDocToAwb }
                  handleClick={ this.handleClick }
                  onChange={ this.onChange }
                  attachToType={ this.state.attachToType }
                  attachToTypeError={ this.state.attachToTypeError }
                  order_num={ this.state.order_num }
                  orderNumError={ this.state.orderNumError }
                  rfs_no={ this.state.rfs_no }
                  rfsNoError={ this.state.rfsNoError }
                  rfsDate={ this.state.rfsDate }
                  attachmentType = {this.state.attachmentType}
                  changeAttachmentType = { this.changeAttachmentType } 
                  attachmentOtherName = { this.state.attachmentOtherName }
                  progressBar={ this.state.progress }
                />
              </Grid>
            </Grid>
            { this.state.isAttachmentDeleteConfirmationOpen &&
              <ConfirmationDialog
                open={ this.state.isAttachmentDeleteConfirmationOpen }
                close={ () => { this.setState({ isAttachmentDeleteConfirmationOpen: false }) } }
                title='Delete Confirmation'
                text='Your file will be permanently removed. To confirm deletion click on the “Delete” button.'
                textConfirm='delete'
                confirm={ this.deleteUnrecognizedDoc }
                showCloseIcon={ true }
              />
            }
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageUnrecognizedDocContainer);
